/* Shop For Links redesign v11 - shared behaviors (scroll reveal, marquees, home demo window) */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* duplicate horizontal marquee tracks for a seamless loop */
  document.querySelectorAll("[data-dup]").forEach(function (track) {
    var half = track.children.length;
    track.innerHTML += track.innerHTML;
    Array.prototype.forEach.call(track.children, function (el, i) {
      if (i >= half) el.setAttribute("aria-hidden", "true");
    });
  });

  /* duplicate vertical publisher list for the auto-scroll loop */
  document.querySelectorAll("[data-dup-v]").forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* scroll reveal */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -40px 0px" });
    document.querySelectorAll(".rv:not(.in)").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".rv").forEach(function (el) { el.classList.add("in"); });
  }

  /* animated counters */
  var fmt = new Intl.NumberFormat("en-US");
  if ("IntersectionObserver" in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute("data-count"), 10);
        var prefix = el.getAttribute("data-prefix") || "";
        var suffix = el.getAttribute("data-suffix") || "";
        if (reduced || isNaN(target)) {
          el.textContent = prefix + fmt.format(target) + suffix;
          return;
        }
        var t0 = performance.now(), dur = 1200;
        var tick = function (t) {
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + fmt.format(Math.round(target * eased)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll("[data-count]").forEach(function (el) { cio.observe(el); });
  }

  /* linkpilot mini-flow (home demo) */
  var lp = (function () {
    var steps = document.querySelectorAll("#lpSteps span");
    var panels = document.querySelectorAll("#lpPanels .lp-panel");
    if (!steps.length || !panels.length) return null;
    var idx = 0;
    function render() {
      steps.forEach(function (s, i) { s.classList.toggle("on", i === idx); });
      panels.forEach(function (p, i) { p.classList.toggle("active", i === idx); });
    }
    function tick() { idx = (idx + 1) % panels.length; render(); }
    function reset() { idx = 0; render(); }
    render();
    if (!reduced) setInterval(tick, 1800);
    return { reset: reset };
  })();

  /* home demo window: auto-cycling scenes */
  (function () {
    var CYCLE = 9000;
    var order = ["backlinks", "packages", "indexing", "linkpilot"];
    var tabs = document.getElementById("demoTabs");
    var scenes = document.getElementById("demoScenes");
    var winEl = document.getElementById("demoWindow");
    if (!tabs || !scenes || !winEl) return;
    var current = "backlinks";
    var timer = null;
    var packageTimer = null;
    var indexingTimer = null;
    var packageIdx = 0;
    var indexingIdx = 0;

    function rotatePackages(reset) {
      var cards = Array.prototype.slice.call(scenes.querySelectorAll('[data-scene="packages"] [data-package-option]'));
      var dots = Array.prototype.slice.call(scenes.querySelectorAll(".package-selection-dots i"));
      if (!cards.length) return;
      if (reset) packageIdx = 0;
      cards.forEach(function (card, i) { card.classList.toggle("is-selected", i === packageIdx); });
      dots.forEach(function (dot, i) { dot.classList.toggle("on", i === packageIdx); });
      packageIdx = (packageIdx + 1) % cards.length;
    }

    function startPackageMotion(reset) {
      clearInterval(packageTimer);
      packageTimer = null;
      rotatePackages(reset);
      if (!reduced) packageTimer = setInterval(function () { rotatePackages(false); }, 1500);
    }

    function rotateIndexing(reset) {
      var steps = Array.prototype.slice.call(scenes.querySelectorAll('[data-scene="indexing"] [data-index-step]'));
      var rows = Array.prototype.slice.call(scenes.querySelectorAll('[data-scene="indexing"] [data-index-row]'));
      var bar = scenes.querySelector('[data-scene="indexing"] .sfl-indexing-progress span');
      if (!steps.length) return;
      if (reset) indexingIdx = 0;
      steps.forEach(function (step, i) {
        step.classList.toggle("active", i <= indexingIdx);
        step.classList.toggle("is-current", i === indexingIdx);
      });
      rows.forEach(function (row, i) {
        row.classList.toggle("is-updating", i === indexingIdx % rows.length);
        row.classList.toggle("is-complete", i < indexingIdx % (rows.length + 1));
      });
      if (bar) bar.style.width = (((indexingIdx + 1) / steps.length) * 100) + "%";
      indexingIdx = (indexingIdx + 1) % steps.length;
    }

    function startIndexingMotion(reset) {
      clearInterval(indexingTimer);
      indexingTimer = null;
      rotateIndexing(reset);
      if (!reduced) indexingTimer = setInterval(function () { rotateIndexing(false); }, 1500);
    }

    function stopSceneMotion() {
      clearInterval(packageTimer);
      clearInterval(indexingTimer);
      packageTimer = null;
      indexingTimer = null;
    }

    function startSceneMotion(name, reset) {
      stopSceneMotion();
      if (name === "packages") startPackageMotion(reset);
      if (name === "indexing") startIndexingMotion(reset);
    }

    function show(name) {
      current = name;
      if (name === "linkpilot" && lp) lp.reset();
      startSceneMotion(name, true);
      scenes.querySelectorAll(".scene").forEach(function (s) {
        s.classList.toggle("active", s.getAttribute("data-scene") === name);
      });
      tabs.querySelectorAll("button").forEach(function (b) {
        var on = b.getAttribute("data-scene") === name;
        b.classList.toggle("active", on);
        b.classList.remove("run");
        if (on && !reduced) { void b.offsetWidth; b.classList.add("run"); }
      });
    }

    function next() { show(order[(order.indexOf(current) + 1) % order.length]); }
    function start() {
      startSceneMotion(current, false);
      if (!reduced && !timer) timer = setInterval(next, CYCLE);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
      stopSceneMotion();
    }

    tabs.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-scene]");
      if (!btn) return;
      stop(); show(btn.getAttribute("data-scene")); start();
    });
    winEl.addEventListener("mouseenter", stop);
    winEl.addEventListener("mouseleave", start);
    tabs.addEventListener("mouseenter", stop);
    tabs.addEventListener("mouseleave", start);

    startSceneMotion(current, true);
    start();
  })();

  /* animated how-it-works stepper */
  (function () {
    var wrap = document.querySelector(".steps[data-hw]");
    if (!wrap || reduced) return;
    var steps = Array.prototype.slice.call(wrap.querySelectorAll(".step"));
    var t = 0;
    function render() {
      steps.forEach(function (s, i) {
        s.classList.toggle("hw-done", i < t);
        s.classList.toggle("hw-active", i === t && t < steps.length);
      });
    }
    render();
    setInterval(function () {
      t = t + 1;
      if (t > steps.length + 1) t = 0;
      render();
    }, 1400);
  })();

  /* copy support email to clipboard */
  document.querySelectorAll("[data-copy-email]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var email = btn.getAttribute("data-copy-email");
      var label = btn.querySelector("[data-copy-label]");
      var done = function () {
        if (!label) return;
        var orig = label.textContent;
        btn.classList.add("copied");
        label.textContent = "Copied " + email + " ✓";
        setTimeout(function () { label.textContent = orig; btn.classList.remove("copied"); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(done, function () { fallbackCopy(email, done); });
      } else {
        fallbackCopy(email, done);
      }
      function fallbackCopy(text, cb) {
        var ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand("copy"); cb(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });

  /* bundles hero: roaming highlight across package minis */
  (function () {
    var grid = document.querySelector(".hp-grid");
    if (!grid || reduced) return;
    var minis = grid.querySelectorAll(".hp-mini");
    if (minis.length < 2) return;
    var idx = 0;
    minis.forEach(function (m, k) { if (m.classList.contains("on")) idx = k; });
    var timer = null;
    function render() {
      minis.forEach(function (m, k) { m.classList.toggle("on", k === idx); });
    }
    function next() { idx = (idx + 1) % minis.length; render(); }
    function start() { if (!timer) timer = setInterval(next, 2200); }
    function stop() { clearInterval(timer); timer = null; }
    minis.forEach(function (m, k) {
      m.addEventListener("mouseenter", function () { stop(); idx = k; render(); });
    });
    grid.addEventListener("mouseleave", start);
    start();
  })();
})();
